<template>
  <div class="no-data">
    <img v-if="!noImg" src="@/assets/images/no-data.png" alt="">
    <div v-if="!noTxt" class="ml-20 color-ccc">
      <p v-if="text" v-html="text" />
      <template v-else>
        <p>抱歉，没有找到相关结果。建议：</p>
        <p>1、请您尝试简化输入词</p>
        <p>2、请您尝试减少筛选条件</p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noImg: {
      type: Boolean,
      default: false
    },
    noTxt: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-data{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    //padding: 150px 0;
    img{
      max-width: 320px;
			max-height: 100%;
			object-fit: contain;
    }
  }
</style>
